<template>
    <app-dashboard-tiles :title="title" :legend-title="legendTitle" chart-classes="w-full h-64">
        <template v-slot:chart>
            <bar-chart :data="data" :options="options" :style="height ? { height } : ''" />
        </template>
        <template v-slot:legendFooter>
            <slot name="legendFooter"></slot>
        </template>
        <template v-slot:icon>
            <slot name="icon"></slot>
        </template>
    </app-dashboard-tiles>
</template>
<script>
import AppDashboardTiles from '@/components/app-dashboard-tiles/AppDashboardTiles.vue';
import { Bar } from 'vue-chartjs';

const BarChart = {
    extends: Bar,
    props: ['chartData', 'options'],
};
export default {
    components: { AppDashboardTiles, BarChart },
    props: {
        title: { type: String, default: () => '' },
        legendTitle: { type: String, default: () => '' },
        data: { type: Object, default: () => [] },
        height: { type: String },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        ticks: {
                            display: true,
                            autoSkip: false,
                        },
                        min: 0,
                    },
                    x: {},
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        display: false,
                    },
                },
            }),
        },
    },
};
</script>
